import React, {Component} from 'react';
import {Menu, Icon, Header, Table, Form, Select, Button} from 'semantic-ui-react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import BranchOfficeData from "../../data/BranchOfficeData";
import Auth from "../../data/auth";

let GLOBAL = require('../../data/globals');


class FilterBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            branch_offices: [],
            branch_office: {
                id: '',
                name: ''
            },
            downloading: false,
            date_error: false,
            date: moment().format('MM/DD/YYYY'),
            show_date: this.props.show_date === true || this.props.show_date === undefined
        };

        this.handleBranchOfficeChange = this.handleBranchOfficeChange.bind(this);
        this.handleDateClick = this.handleDateClick.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        this.getBranchOffices();
    }

    async getBranchOffices() {
        let branch_offices = await BranchOfficeData.listAll();
        this.setState({branch_offices});
        this.handleBranchOfficeChange(branch_offices[0].key)
    }

    handleBranchOfficeChange = (result) => {
        this.props.callbackGetFilter(result, this.state.date);
        this.setState({branch_office: {id: result, name: result}});
    };

    handleDateClick = (selectedDay) => {
        let date = moment(selectedDay).format("MM/DD/YYYY");
        this.setState({date_error: false, date});
        this.props.callbackGetFilter(this.state.branch_office.id, date);
    };

    handleDateChange = (event) => {
        this.setState({date: event.target.value});
        if (event.target.value.trim() === '') {
            this.setState({date_error: true})
        } else {
            this.setState({date_error: false});
        }
    };

    handleDownload = () =>{
        this.setState({downloading:true})
        Auth.tokenUID().then(res => {
            if(res.token){
                let report_url = `${GLOBAL.BASE_URL}api/${this.props.url_download}?token=${res.token}&uid=${res.uid}&date=${this.state.date}&branch_office=${this.state.branch_office.id}`;
                let link =   document.createElement("a");
                link.download = 'download';
                link.href = report_url;
                link.click();
            }
        }).catch((error) => console.log(error)).finally(() => { this.setState({downloading:false}); });
    };

    render() {
        return (
            <Table.Header fullWidth>
                <Table.Row>
                    <Table.HeaderCell colSpan='2'>
                        <Menu secondary>
                            <Menu.Item>
                                <Header as='h2'>
                                    <Icon name='bar chart'/>
                                    <Header.Content>
                                        {this.props.title}
                                    </Header.Content>
                                </Header>
                            </Menu.Item>
                            <Menu.Menu>
                                <Menu.Item>
                                    <Form>
                                        <Form.Group inline>
                                            <Form.Field>
                                                <label>Sucursal:</label>
                                                <Select options={this.state.branch_offices}
                                                        onChange={(e, {value}) => this.handleBranchOfficeChange(value)}
                                                        value={this.state.branch_office.id} placeholder='Sucursal'
                                                        error={this.state.branch_office_error} width={4}/>
                                            </Form.Field>
                                            {this.state.show_date ? <label>Fecha:</label>:null}
                                            {this.state.show_date ? <Form.Field error={this.state.date_error}>
                                                <DayPickerInput readOnly placeholder="MM/DD/YYYY" format="MM/DD/YYYY"
                                                                value={this.state.date}
                                                                onDayChange={this.handleDateClick}
                                                                onChange={this.handleDateChange}/>
                                            </Form.Field>:null}
                                            {this.props.download ? <Button icon='download' loading={this.state.downloading} disabled={this.state.downloading} labelPosition='left' content="Descargar" onClick={this.handleDownload}/>:null}
                                        </Form.Group>
                                    </Form>
                                </Menu.Item>
                            </Menu.Menu>
                        </Menu>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
        );
    }
}

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/reports/FilterBar.js